import dayjs from "dayjs";
import { ISmsTime } from "us.collection.admin/interfaces";

export function smsTime(this: number): Array<ISmsTime>{
  return [
    {
      dayId: 1,
      day: "Monday",
      isEnable: false,
      timeSlots: [{ id: -1, startTime: dayjs().year(this).set('hour', 8).set('minute', 0), endTime: dayjs().year(this).set('hour', 20).set('minute', 0) }],
    },
    {
      dayId: 2,
      day: "Tuesday",
      isEnable: false,
      timeSlots: [{ id: -1, startTime: dayjs().year(this).set('hour', 8).set('minute', 0), endTime: dayjs().year(this).set('hour', 20).set('minute', 0) }],
    },
    {
      dayId: 3,
      day: "Wednesday",
      isEnable: false,
      timeSlots: [{ id: -1, startTime: dayjs().year(this).set('hour', 8).set('minute', 0), endTime: dayjs().year(this).set('hour', 20).set('minute', 0) }],
    },
    {
      dayId: 4,
      day: "Thursday",
      isEnable: false,
      timeSlots: [{ id: -1, startTime: dayjs().year(this).set('hour', 8).set('minute', 0), endTime: dayjs().year(this).set('hour', 20).set('minute', 0) }],
    },
    {
      dayId: 5,
      day: "Friday",
      isEnable: false,
      timeSlots: [{ id: -1, startTime: dayjs().year(this).set('hour', 8).set('minute', 0), endTime: dayjs().year(this).set('hour', 20).set('minute', 0) }],
    },
    {
      dayId: 6,
      day: "Saturday",
      isEnable: false,
      timeSlots: [{ id: -1, startTime: dayjs().year(this).set('hour', 8).set('minute', 0), endTime: dayjs().year(this).set('hour', 20).set('minute', 0) }],
    },
    {
      dayId: 7,
      day: "Sunday",
      isEnable: false,
      timeSlots: [{ id: -1, startTime: dayjs().year(this).set('hour', 8).set('minute', 0), endTime: dayjs().year(this).set('hour', 20).set('minute', 0) }],
    },
  ];
}
